<div class="comment-cell flex-row align-center g-space-sm">
  <cam-font-icon class="comment-icon" name="infos" type="sm"></cam-font-icon>
  <cam-text class="flex-1" size="sm">{{ this.data?.description ?? '' }}</cam-text>
</div>
